define('presentation/settings/closeAccount/presentationObjects/closeAccountTooExpensiveFeedbackReasonPresentationObject',[],function() {
    return function(){
        let self = this;
        self.text = null;
        self.value = null;
    };
});

